// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title_Jko6V","right":"Title_right_3VGZa","left":"Title_left_eAB0T"};